import moment from "moment";

// Field names follow the Fixtures style, e.g. "Quarter Final Game 1 Team 1
// Name". Team 1 is the upper slot in the tree rather than the home side, as
// home and away swap between legs. Score is the aggregate, so single-leg and
// two-legged rounds share fields; the Leg fields only fill in for two-legged
// ties. Rounds before the start round go out blank with "{Round} Visible" off.
const ROUND_FIELD_NAMES = {
  RoundOf16: "Round of 16",
  QuarterFinal: "Quarter Final",
  SemiFinal: "Semi Final",
  Final: "Final",
};

export class TournamentTree {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "TournamentTree";
    this.scene = "Tournament Tree";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.options = options;
    this.data = [];

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    options.rounds?.forEach((round) => {
      let roundName = ROUND_FIELD_NAMES[round.key];
      this.data.push({
        name: roundName + " Visible",
        value: { visible: round.visible },
      });
      round.ties?.forEach((tie, index) => {
        this.pushTie(
          roundName + " Game " + (index + 1),
          round.visible ? tie : null,
        );
      });
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  pushTie(prefix, tie) {
    [1, 2].forEach((n) => {
      let team = tie?.["team" + n];
      let pens = tie?.["team" + n + "Pens"];

      this.data.push({
        name: `${prefix} Team ${n} Code`,
        value: { text: team?.code || "" },
      });
      this.data.push({
        name: `${prefix} Team ${n} Name`,
        value: { text: team?.name || "" },
      });
      this.data.push({
        name: `${prefix} Team ${n} Short Name`,
        value: { text: team?.short_name || "" },
      });
      this.data.push({
        name: `${prefix} Team ${n} Badge`,
        value: {
          image: team?.variables?.badge
            ? "${user}" + team.variables.badge
            : "",
        },
      });
      // Scores stay blank until a game has kicked off, rather than showing 0.
      this.data.push({
        name: `${prefix} Team ${n} Score`,
        value: {
          text: tie?.started ? String(tie["team" + n + "Score"]) : "",
        },
      });
      this.data.push({
        name: `${prefix} Team ${n} Pen Score`,
        value: {
          text: pens !== null && pens !== undefined ? "(" + pens + ")" : "",
        },
      });
      this.data.push({
        name: `${prefix} Team ${n} Winner`,
        value: { visible: tie?.winner === n },
      });
      [1, 2].forEach((leg) => {
        let legData = tie?.legs?.length === 2 ? tie.legs[leg - 1] : null;
        this.data.push({
          name: `${prefix} Leg ${leg} Team ${n} Score`,
          value: {
            text: legData?.started ? String(legData["team" + n + "Goals"]) : "",
          },
        });
      });
    });

    this.data.push({
      name: `${prefix} Status`,
      value: { text: tie?.status || "" },
    });
    this.data.push({
      name: `${prefix} Date`,
      value: { text: tie?.date || "" },
    });
    this.data.push({
      name: `${prefix} Kick Off`,
      value: {
        text: tie?.date
          ? moment(`${tie.date} ${tie.time}`, "YYYY-MM-DD HH:mmZ").format(
              "HH:mm",
            )
          : "",
      },
    });
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
  }

  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
